import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative mt-24" style={{ borderTop: "1px solid var(--gt-border)" }}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="font-display text-2xl mb-3">Trenton Franklin / First Landing Studio</div>
                    <p className="text-sm leading-relaxed" style={{ color: "var(--gt-text-2)" }}>
                        A remote-first editorial photojournalism agency based in Guatemala. Verified field content,
                        custom shoots, and rights-managed archive licensing for international NGOs — from grassroots
                        advocates to global humanitarian agencies.
                    </p>
                    <div className="mt-6 flex items-center gap-3">
                        <a className="gt-link text-sm" href="https://firstlanding.co" target="_blank" rel="noreferrer" data-testid="footer-site-link">
                            firstlanding.co <i className="fa-solid fa-arrow-up-right-from-square ml-1" style={{ fontSize: 10 }}></i>
                        </a>
                        <span style={{ color: "var(--gt-muted)" }}>·</span>
                        <a className="gt-link text-sm" href="mailto:contact@trentonfranklin.com" data-testid="footer-email-link">
                            contact@trentonfranklin.com
                        </a>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <div className="overline mb-4">Services</div>
                    <ul className="space-y-2 text-sm" style={{ color: "var(--gt-text-2)" }}>
                        <li><a href="/#services" className="hover:text-white">Field Content Subscriptions</a></li>
                        <li><a href="/#services" className="hover:text-white">On-Demand Shoot Network</a></li>
                        <li><a href="/#services" className="hover:text-white">Verification & Monitoring</a></li>
                        <li><a href="/#services" className="hover:text-white">Archive Licensing</a></li>
                        <li><a href="/#services" className="hover:text-white">NGO Training</a></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="overline mb-4">Provenance & Trust</div>
                    <p className="text-sm leading-relaxed" style={{ color: "var(--gt-text-2)" }}>
                        Every image we license carries <strong style={{ color: "var(--gt-text)" }}>Content Provenance and Authenticity (C2PA)</strong> metadata,
                        a signed consent release from every subject, and the GPS location it was taken. Real
                        photographs only. No AI-generated images.
                    </p>
                    <div className="mt-4 flex gap-2 flex-wrap">
                        <span className="meta-chip"><span className="verif-dot"></span> C2PA Verified</span>
                        <span className="meta-chip"><i className="fa-solid fa-shield-halved" style={{ fontSize: 10 }}></i> Consent on file</span>
                        <span className="meta-chip"><i className="fa-solid fa-location-dot" style={{ fontSize: 10 }}></i> Location tagged</span>
                    </div>
                </div>
            </div>
            <div className="border-t" style={{ borderColor: "var(--gt-border)" }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <div className="overline">© {new Date().getFullYear()} First Landing Studio · Trenton Franklin</div>
                    <div className="overline" style={{ color: "var(--gt-muted)" }}>No AI image generation — ever. Real photographs only.</div>
                </div>
            </div>
        </footer>
    );
}
